<!--
 * @Author: wsx
 * @Date: 2022-01-05 18:45:47
 * @LastEditTime: 2023-01-10 19:01:39
 * @LastEditors: zhaoshuai 894028693@qq.com
 * @Description:重点车辆中卡口穿梭框应用
-->
<template>
  <el-dialog
    v-model="formVisible"
    title="卡口选择"
    width="50%"
    @close="closeDialog"
  >
    <div v-show="!pathVisible">
      <div class="TransferApplication" v-loading="loading" v-show="!mapActive">
        <h-transfer
          ref="transferRef"
          v-model="transferKeys"
          nodeKey="cameraId"
          checkedKey="cameraId"
          :props="{ value: 'treeId', label: 'name' }"
          :data="treeData"
          :default-expanded-keys="[rootNodeKey]"
          :titles="['待选', '已选']"
          :showDefineTree="true"
        >
        </h-transfer>
      </div>
      <mapSelectTransfer
        class="box-map"
        ref="mapSelectRef"
        v-if="mapActive"
        :allCameraList="videoData.cameraBaseDtls"
      ></mapSelectTransfer>
    </div>
    <div v-show="pathVisible" class="pathChoose">
      <span @click="backTree">返回资源树选择</span>
      <div class="pathChoose_header">
        <span
          >已选卡口（卡口数目最少选择 2 个，最多选择 10 个，多于 10 个的只显示前
          10 个）</span
        >
        <span>
          <h-icon
            icon="icon-xiayi"
            font-size="24"
            @click="arrowPreview"
          ></h-icon>
          <h-icon
            icon="icon-shangyi"
            font-size="24"
            @click="arrowNext"
          ></h-icon>
          <h-icon
            icon="icon-guanbi2"
            font-size="24"
            @click="deletePathChoose"
          ></h-icon>
        </span>
      </div>
      <div class="pathChoose_content">
        <template v-for="(item, index) in pathArray" :key="index">
          <span
            :class="{ activedraggable: item.cameraName == activeName }"
            @click="btnClick(item, index)"
            >{{ item.cameraName }}</span
          >
        </template>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <div class="map" @click="changeMapActive" v-if="!pathVisible">
          <h-icon icon="icon-weizhi" font-size="16"></h-icon
          >{{ !mapActive ? "地图选择" : "资源树选择" }}
        </div>
        <h-button type="primary" @click="emitCheckList" v-if="!pathVisible"
          >确定</h-button
        >
        <h-button type="primary" @click="sumitPath" v-if="pathVisible"
          >确认</h-button
        >
      </span>
    </template>
  </el-dialog>
</template>
<script>
import { defineComponent, reactive, toRefs, watchEffect, ref } from "vue";
import { toRaw } from "@vue/reactivity";
import {
  queryOrganPersonList,
  queryOrganListId,
  queryOrganList,
} from "@/api/system";
import { getSubType, queryTreeAreaVideo } from "@/api/videoControl/videoApi.js";
import {
  videoFilesList,
  tasksFilesList,
  clueTasks,
} from "@/api/smartApplication/smartApplicationApi.js";
import { getMenutree } from "@/api/system/region.js";
import util from "@util/js";
import { ElMessage } from "element-plus";
export default defineComponent({
  name: "TransferApplication",
  emits: ["transferApplicationList", "update:visible", "closeDialog"],
  components: {},

  props: {
    icon: {
      type: String,
    },
    elIcon: {
      type: String,
    },
    fontSize: {
      type: String,
      default: "16px",
    },
    // 展示弹窗
    visible: {
      type: Boolean,
      default: false,
    },
    // 展示路径排序
    showChoose: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const data = reactive({
      loading: false,
      mapActive: false,
      pathVisible: false,
      pathArray: [],
      activeName: "", // 选中的卡口
      activeNameIndex: 0, // 选中的卡口位置
      areaCameraArryObj: [], // 区域内绑定摄像头   存摄像头对象
      transferKeys: [],
      treeOrganPerson: [],
      rootNodeKey: "",
      videoData: null,
      treeData: [],
      formVisible: false,
    });
    const refData = toRefs(data);
    const mapSelectRef = ref();
    const transferRef = ref();
    // 使用wache监听不报红
    watchEffect(() => {
      data.formVisible = props.visible;
    });
    watchEffect(() => {
      console.log(props.dataType, 9999999);
    });

    const backTree = () => {
      data.pathVisible = false;
    };
    // 获取区域树数据
    const queryOrganPersonListAsycn = async () => {
      let result;
      result = await getMenutree();
      const treeData = [result.data];
      data.treeOrganPerson = treeData;
      queryRealVideoTreeAsync();
    };
    // 获取区域树中所有卡口数据
    const queryRealVideoTreeAsync = async () => {
      data.loading = true;
      // const res = await queryRealVideoTree();
      const params = {
        subType: "1",
      };
      const res = await getSubType(params);
      data.videoData = res;
      const arrayGroup = arrayGroupBy(data.videoData.cameraBaseDtls, "areaId");
      const changeArrayGroup = {};
      arrayGroup.forEach((item) => {
        item.forEach((it) => {
          it.name = it.cameraName;
          it.treeId = "device_" + it.deviceId;
        });
        changeArrayGroup[item[0].areaId] = item;
      });
      const changeArrayGroupArray = Object.keys(changeArrayGroup);
      const getChildren = (obj) => {
        for (const key in obj) {
          if (key == "children") {
            obj[key].forEach((item) => {
              getChildren(item);
              if (changeArrayGroupArray.includes(item.id + "")) {
                changeArrayGroup[item.id].forEach((it) => {
                  item.children.push(it);
                });
              }
            });
          }
        }
      };
      getChildren(data.treeOrganPerson[0]);
      data.treeData = data.treeOrganPerson;
      data.loading = false;
    };
    const emitCheckList = () => {
      if (props.showChoose) {
        if (!data.mapActive) {
          data.pathArray = data.transferKeys;
        } else {
          data.pathArray = mapSelectRef.value.selectPoint;
        }

        data.pathArray = data.pathArray.filter((item, index) => {
          if (index < 10) return item;
        });
        data.pathVisible = true;
      } else {
        context.emit("update:visible", false);
        if (!data.mapActive) {
          context.emit("transferApplicationList", data.transferKeys);
        } else {
          context.emit(
            "transferApplicationList",
            mapSelectRef.value.selectPoint
          );
        }
      }
    };
    const arrayGroupBy = (list, groupId) => {
      const sorted = groupBy(list, (item) => {
        return [item[groupId]];
      });
      return sorted;
    };
    const groupBy = (arr, f) => {
      const groups = {};
      arr.forEach((o) => {
        const group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
      });
      return Object.keys(groups).map((group) => {
        return groups[group];
      });
    };
    const closeDialog = () => {
      context.emit("update:visible", false);
      context.emit("closeDialog");
    };
    const changeMapActive = () => {
      if (data.loading) {
        ElMessage.warning("请稍等正在加载数据");
        return;
      }
      data.mapActive = !data.mapActive;
      data.areaCameraArryObj = transferRef.value.selectedList;
    };
    const btnClick = (el, index) => {
      data.activeName = el.cameraName;
      data.activeNameIndex = index;
    };
    const deletePathChoose = () => {
      if (data.activeName == "") {
        ElMessage.warning("请选择要删除的卡口");
        return;
      }
      data.pathArray = data.pathArray.filter((item, index) => {
        if (index != data.activeNameIndex) return item;
      });
    };
    // 下移
    const arrowNext = () => {
      if (data.activeName == "") {
        ElMessage.warning("请选择要排序的卡口");
        return;
      }
      if (data.activeNameIndex <= 0) {
        ElMessage.warning("已到最前一项");
        return;
      } else {
        data.activeNameIndex = data.activeNameIndex - 1;
      }
      const arr = data.pathArray.splice(data.activeNameIndex, 1);
      data.pathArray.splice(data.activeNameIndex + 1, 0, arr[0]);
    };
    // 上移
    const arrowPreview = () => {
      if (data.activeName == "") {
        ElMessage.warning("请选择节点");
        return;
      }
      const arr = data.pathArray.splice(data.activeNameIndex, 1);
      data.pathArray.splice(data.activeNameIndex + 1, 0, arr[0]);
      if (data.activeNameIndex >= data.pathArray.length - 1) {
        ElMessage.warning("已到最后一项");
      } else {
        data.activeNameIndex = data.activeNameIndex + 1;
      }
    };
    const sumitPath = () => {
      context.emit("transferApplicationList", data.pathArray);
      context.emit("update:visible", false);
    };
    queryOrganPersonListAsycn();
    return {
      ...refData,
      transferRef,
      backTree,
      emitCheckList,
      closeDialog,
      mapSelectRef,
      changeMapActive,
      arrowPreview,
      arrowNext,
      btnClick,
      deletePathChoose,
      sumitPath,
    };
  },
});
</script>
<style lang="scss" scoped>
.el-dialog {
  position: relative;
  .TransferApplication {
    height: 50vh;
  }
  .box-map {
    height: 50vh;
  }
  .dialog-footer {
    width: 100%;
    padding-bottom: 8px;

    .map {
      position: absolute;
      left: 0;
      width: 150px;
      font-size: 16px;
      line-height: 34px;
      color: brown;
      cursor: pointer;
    }
  }
  .pathChoose {
    height: 50vh;
    span {
      cursor: pointer;
    }
    .pathChoose_header {
      height: 3vh;
      padding: 20px 80px 30px 80px;
      display: flex;
      justify-content: space-between;
    }
    .pathChoose_content {
      height: 45vh;
      padding: 12px 0 0 30px;
      margin: 0 80px;
      border: 1px solid #c9c9c9;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      span {
        line-height: 32px;
        cursor: pointer;
        font-size: 16px;
        padding-left: 10px;
        &:hover {
          color: #5584ff;
          background-color: #ecf5fd;
        }
      }
      .activedraggable {
        color: #5584ff;
        background-color: #ecf5fd;
      }
    }
  }
}
</style>
